export const DEFAULT_DATA = {
  'Sale Type': 'Travel',
  'Sector': 'Travel'
}
